import {
  Agenda,
  AttendeeMediaKitPage,
  BookNowPage,
  BookNowCheckoutPage,
  BusinessPartnerEventinfoPage,
  CoLocatedEventsPage,
  Community,
  EventContactPage,
  EventHome,
  EventNotFound,
  EventPage,
  FAQPage,
  IcebreakerExplanationPage,
  HelmetPage,
  NotFound,
  PartnerPage,
  Partners,
  PartneringPackagesPage,
  PartneringPackagesDetailsPage,
  PortfolioDetails,
  PortfolioHome,
  OurTeamPage,
  ROUTES,
  Speakers,
  WhoAndWhy,
  ChallengeYourPeersExplanationSpeakersPage,
  WorldCafeExplanationForSpeakersPage,
  PastCommunityPage,
  WebinarPage,
  CareerPage,
  PrivacyYourDataPage,
  PrivacyTakeControlPage,
  PrivacySecurityPage,
  ImprintPage,
  NewsletterUnsubscribePage,
  TermsAndConditionsPage,
  OurAwardsPage,
  AwardsPage,
  AboutUsPage,
  ContactPage,
  SocialResponsibilityPage,
  OurProductPortfolioPage,
  MultiTouchpointNetworkingPage,
  IceBreakerPage,
  EveningNetworkingPage,
  NetworkingDinnerPage,
  ContentHubPage,
  ClientSidePdfGeneratorPage,
  PDFViewerPage,
  RegisterPage,
  ContentHubDetailsPage,
  DeclarationOfConsentPage,
  VendorOnsiteRegistrationPage,
  YearlySurveyPage,
  MktVipPassPage,
  EventGuideUpdatePage,
  AttendeeListRegPage,
  PastAttendeeListRegPage,
  PastAttendeeListPage,
  BPPackagesRegPage,
  OfferDownloadPage,
  BookingTeamPass,
  MultiTouchpointNetworkingPageEvent,
  OemTicketPage,
  VipClientTicket,
  PrivacyOverviewPage,
  PrivacyAntiSpamPolicyPage,
  PrivacyPolicyPage,
  PrivacyContactUsPage,
  PrivacyPolicyFacebookPage,
  BlogsHomePage,
  BlogDetailsPage,
  BlogWebinarDetailsPage,
  BlogsB2BLeadservicePage,
  BlogsDigitalBusinessHubBooNowPage,
  EventsDefaultPage,
} from '@constants/routes';
import { Navigate, Route, Routes } from 'react-router-dom';

import LoadingFallBack from './layouts/components/LoadingFallback';
import { Suspense } from 'react';
import { getUrl } from '@utils/fn';
import { useScrollToTop } from '@utils/hooks';
import { useTranslation } from 'react-i18next';
import SpeakerPage from '@pages/SpeakerPage';
import CompanyLayout from './layouts/components/CompanyLayout';
import ErrorPage404 from '@pages/ErrorPage404';
import { usePageTracking } from '@utils/hooks/usePageTracking';
import BlogsLayout from './layouts/components/BlogsLayout';
import BlogWhitepaperDownloadDetailPage from '@pages/BlogWhitepaperDownloadDetailPage';

const RoutesRoot = () => {
  const { t } = useTranslation();
  useScrollToTop();
  usePageTracking();

  return (
    <Suspense fallback={<LoadingFallBack />}>
      <Routes>
        <Route element={<CompanyLayout />}>
          <Route path="/" element={<HelmetPage />}>
            <Route index element={<PortfolioHome />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-your-data-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyYourDataPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-security-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacySecurityPage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.privacy-anti-spam-policy-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyAntiSpamPolicyPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-take-control-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyTakeControlPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-policy-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyPolicyPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-contact-us-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyContactUsPage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.privacy-facebook-policy-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyPolicyFacebookPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.privacy-overview-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<PrivacyOverviewPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.career-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<CareerPage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.newsletter-unsubscribe-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<NewsletterUnsubscribePage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.multitouchpoint-networking-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<MultiTouchpointNetworkingPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.terms-and-conditions-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<TermsAndConditionsPage />} />
          </Route>

          {/* Our Awards Page is not active yet */}
          {/* <Route
            path={getUrl(t('mappable-company-routes.our-awards-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<OurAwardsPage />} />
          </Route> */}

          <Route
            path={getUrl(t('mappable-company-routes.about-us-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<AboutUsPage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.social-responsibility-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<SocialResponsibilityPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.contact-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<ContactPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.imprint-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<ImprintPage />} />
          </Route>

          <Route
            path={getUrl(t('mappable-company-routes.our-team-url'))}
            element={<HelmetPage />}
          >
            <Route index element={<OurTeamPage />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.our-product-portfolio-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<OurProductPortfolioPage />} />
          </Route>

          <Route
            path={`${getUrl(
              t('mappable-company-routes.our-product-portfolio-url')
            )}/:portfolioSlug`}
            element={<HelmetPage />}
          >
            <Route index element={<PortfolioDetails />} />
          </Route>

          <Route
            path={getUrl(
              t('mappable-company-routes.declaration-of-consent-url')
            )}
            element={<HelmetPage />}
          >
            <Route index element={<DeclarationOfConsentPage />} />
          </Route>

          <Route path={'/events'} element={<HelmetPage />}>
            <Route index element={<EventsDefaultPage />} />
          </Route>
        </Route>

        {false && (
          <Route element={<BlogsLayout />}>
            <Route path={t(ROUTES.INDUSTRY_HUBS)} element={<HelmetPage />}>
              <Route index element={<BlogsHomePage />} />

              {/* ✅ webinar details */}
              <Route path="content-driven-b2b-lead-data-solutions">
                <Route index element={<BlogsB2BLeadservicePage />} />
              </Route>

              {/* ✅ webinar details */}
              <Route path="webinar">
                <Route
                  path=":webinarSlug"
                  element={<BlogWebinarDetailsPage />}
                />
              </Route>

              {/* ✅ whitepaper download details */}
              <Route path="whitepaper-download">
                <Route
                  path=":whitepaperSlug"
                  element={<BlogWhitepaperDownloadDetailPage />}
                />
              </Route>

              {/* ✅ blog-specific book now */}
              <Route path={`:blogsSlug${t('book-now-url')}`}>
                <Route index element={<BlogsDigitalBusinessHubBooNowPage />} />
              </Route>

              {/* ✅ regular blog posts */}
              <Route path=":blogsSlug" element={<BlogDetailsPage />} />
            </Route>
          </Route>
        )}

        <Route
          path={`${t(ROUTES.WEBINARS)}/:eventSlug`}
          element={<HelmetPage />}
        >
          <Route index element={<WebinarPage />} />
        </Route>

        <Route path={`${t(ROUTES.EVENTS)}/:eventSlug`} element={<HelmetPage />}>
          <Route index element={<EventHome />} />

          {/* Redirects START */}
          <Route
            path="event-info"
            element={<Navigate to={`../${getUrl(t('faq-url'))}`} replace />}
          />
          <Route
            path={getUrl(t('icebreaker-url'))}
            element={<Navigate to={`../`} replace />}
          />
          <Route
            path={getUrl(t('evening-networking-url'))}
            element={<Navigate to={`../`} replace />}
          />
          <Route
            path={getUrl(t('networking-dinner-url'))}
            element={<Navigate to={`../`} replace />}
          />
          <Route
            path={getUrl(t('icebreaker-explanation-for-speakers-url'))}
            element={<Navigate to={`../`} replace />}
          />

          {/* Redirects END */}

          <Route path={getUrl(t('register-url'))} element={<RegisterPage />} />
          <Route path={getUrl(t('agenda-url'))} element={<Agenda />} />
          <Route path={getUrl(t('book-now-url'))} element={<BookNowPage />} />
          <Route
            path={getUrl(t('jetzt-teilnehmen-url'))}
            element={<BookNowPage />}
          />
          <Route
            path={getUrl(t('book-now-checkout-url'))}
            element={<BookNowCheckoutPage />}
          />
          <Route
            path={getUrl(t('content-hub-url'))}
            element={<ContentHubPage />}
          />
          <Route
            path={getUrl(t('pdf-viewer-url'))}
            element={<PDFViewerPage />}
          />
          <Route
            path={getUrl(t('icebreaker-url'))}
            element={<IceBreakerPage />}
          />
          <Route
            path={getUrl(t('evening-networking-url'))}
            element={<EveningNetworkingPage />}
          />
          <Route
            path={getUrl(t('networking-dinner-url'))}
            element={<NetworkingDinnerPage />}
          />
          <Route path={getUrl(t('speakers-url'))} element={<Speakers />} />
          <Route path={getUrl(t('awards-url'))} element={<AwardsPage />} />
          <Route
            path={`${getUrl(t('speakers-url'))}/:id`}
            element={<SpeakerPage />}
          />
          <Route
            path={`${getUrl(t('partnering-packages-url'))}`}
            element={<HelmetPage />}
          >
            <Route index element={<PartneringPackagesPage />} />
            <Route path={':id'} element={<PartneringPackagesDetailsPage />} />
          </Route>
          <Route path={getUrl(t('partners-url'))} element={<Partners />} />
          <Route
            path={`${getUrl(t('partners-url'))}/:id`}
            element={<PartnerPage />}
          />
          <Route path={getUrl(t('community-url'))} element={<Community />} />
          <Route
            path={getUrl(t('past-community-url'))}
            element={<PastCommunityPage />}
          />
          <Route
            path={getUrl(t('contact-url'))}
            element={<EventContactPage />}
          />
          <Route path={getUrl(t('faq-url'))} element={<FAQPage />} />
          <Route path={getUrl(t('who-and-why-url'))} element={<WhoAndWhy />} />
          <Route
            path={getUrl(t('co-located-events-url'))}
            element={<CoLocatedEventsPage />}
          />
          <Route
            path={getUrl(t('icebreaker-explanation-for-speakers-url'))}
            element={<IcebreakerExplanationPage />}
          />
          <Route
            path={getUrl(t('attendee-media-kit-url'))}
            element={<AttendeeMediaKitPage />}
          />
          <Route
            path={getUrl(t('business-partner-eventinfo-url'))}
            element={<BusinessPartnerEventinfoPage />}
          />
          <Route
            path={getUrl(t('cyp-explanation-speakers-url'))}
            element={<ChallengeYourPeersExplanationSpeakersPage />}
          />
          <Route
            path={getUrl(t('wc-explanation-for-speakers-url'))}
            element={<WorldCafeExplanationForSpeakersPage />}
          />
          <Route
            path={`${getUrl(t('content-hub-url'))}/:id`}
            element={<ContentHubDetailsPage />}
          />
          <Route
            path={getUrl(t('document-content-hub-url'))}
            element={<ContentHubDetailsPage />}
          />
          <Route
            path={getUrl(t('vendor-onsite-registration-url'))}
            element={<VendorOnsiteRegistrationPage />}
          />
          <Route
            path={getUrl(t('mtpn-page-url'))}
            element={<MultiTouchpointNetworkingPageEvent />}
          />
          <Route
            path={getUrl(t('yearly-survey-page-url'))}
            element={<YearlySurveyPage />}
          />
          <Route
            path={getUrl(t('bp-packages-url'))}
            element={<BPPackagesRegPage />}
          />
          <Route
            path={getUrl(t('eventguide-update-url'))}
            element={<EventGuideUpdatePage />}
          />
          <Route
            path={getUrl(t('attendee-list-reg-url'))}
            element={<AttendeeListRegPage />}
          />
          <Route
            path={getUrl(t('past-attendee-list-reg-url'))}
            element={<PastAttendeeListRegPage />}
          />
          <Route
            path={getUrl(t('past-attendee-list-url'))}
            element={<PastAttendeeListPage />}
          />
          <Route
            path={getUrl(t('mkt-vip-pass-url'))}
            element={<MktVipPassPage />}
          />
          <Route
            path={getUrl(t('team-ticket-url'))}
            element={<BookingTeamPass />}
          />
          <Route
            path={getUrl(t('vip-client-ticket-url'))}
            element={<VipClientTicket />}
          />
          <Route
            path={getUrl(t('oem-ticket-url'))}
            element={<OemTicketPage />}
          />
          <Route
            path={getUrl(t('event-not-found-url'))}
            element={<EventNotFound />}
          />
          <Route path=":pageSlug" element={<EventPage />} />

          <Route path="*" element={<EventHome />} />
        </Route>

        <Route
          path={`${t(ROUTES.WEBINARS)}/:webinarSlug`}
          element={<HelmetPage />}
        />

        <Route
          path={`${getUrl(t('pdf-download-url'))}/:pdfName`}
          element={<ClientSidePdfGeneratorPage />}
        />

        <Route
          path={`${getUrl(t('offer-download-url'))}`}
          element={<OfferDownloadPage />}
        />
        <Route path="/download/offer_draft" element={<OfferDownloadPage />} />

        <Route path={`${getUrl(t('404-url'))}`} element={<ErrorPage404 />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesRoot;
